import { authClient, API } from '../index'

// Get all contacts
export const getAllContacts = () => {
  return authClient().get(`${API}/contact/`)
}

// Get contact by id
export const getContactById = (id) => {
  return authClient().get(`${API}/contact/${id}`)
}

// Create contact
export const postContact = async (contact) => {
  return authClient().post(`${API}/contact/`, contact)
}


// Delete contact
export const deleteContact = (id) => {
  return authClient().delete(`${API}/contact/${id}`)
}

